<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
 /*  mounted() {
    this.api.ywApi.Login().then(res => {
      console.log('System start login success:', res)
    }).catch(err => {
      console.error('System start login failed:', err)
    })
  } */
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue